// API Configuration
// Nutzt relative URLs für Production, localhost für Entwicklung
const getApiUrl = () => {
  // Production: Verwende relative URL (gleicher Origin wie Frontend)
  if (typeof window !== 'undefined' && window.location && window.location.hostname !== 'localhost') {
    return '/api';
  }
  
  // Lokale Entwicklung
  return 'http://localhost:5000/api';
};

const getSocketUrl = () => {
  // Production: Verwende relative URL (gleicher Origin wie Frontend)
  if (typeof window !== 'undefined' && window.location && window.location.hostname !== 'localhost') {
    return '';
  }
  
  // Lokale Entwicklung
  return 'http://localhost:5000';
};

const API_CONFIG = {
  BASE_URL: getApiUrl(),
  SOCKET_URL: getSocketUrl(),
  TIMEOUT: 10000, // 10 Sekunden
};

// Für Backward-Kompatibilität
export const API_URL = API_CONFIG.SOCKET_URL;
export const API_BASE_URL = API_CONFIG.BASE_URL;

export default API_CONFIG;

